import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function BookingConfirm({ slotDetails, userDetails }) {
  const { t } = useTranslation("publicInterviewBooking");
  const { first_name } = useSelector(
    (state) => state.user.user
  );
  return (
    <div className="paymymedium-wrapper">
      <div className="paymymedium-container">
        <div className="">
          <img src="../images/new-cll.png" alt="user" />
          <>
            <h3 className="mt-3">
              {t("bookingConfirm.appointmentConfirmed")}
              {/* {userDetails && userDetails.first_name}, your appointment is
          confirmed */}
            </h3>
            <div className="font-size-17 advance-guest-book-p">
              {t("bookingConfirm.checkEmail")}
            </div>
          </>
          <h5 className="mt-2">
          {t("bookingConfirm.confirmedWithName", { name: userDetails && userDetails.first_name })}
          </h5>
          {console.log(slotDetails,":slotDetails")}
          {/* <span className="advance-guest-book-span">
            
            
          </span>
          <br /> */}
          <p className="advance-guest-book-p">
            {slotDetails &&
              moment(`${slotDetails.date}`, "YYYY-MM-DD hh:mm A").format(
                "LL"
              )}{" "}
          </p>
          <br />
           <p className="advance-guest-book-p">
            {slotDetails &&
              moment(
                `${slotDetails.date} ${slotDetails.time}`,
                "YYYY-MM-DD hh:mm A"
              ).format("hh:mm A")}{" "}
          </p>
          <br />
           <p className="advance-guest-book-p">
            {t("bookingConfirm.withMedium", { name: slotDetails && slotDetails.medium_name })}
          </p>
          <br />
          {/* <span className="advance-guest-book-span">
            {" "}
            An account has been created on VerySoul.com.
            <br /> Please check your email for a temporary password to Login.
          </span> */}
          {/* <div>

      <a className="advance-tag-my-calendar"
        target="_blank"
        href={slotDetails && slotDetails.calendarLink}
      >
        Add to my calendar
      </a>
    </div> */}
          <div className="confirm-btn-host-booking">
            <a
              className=" advance-tag-margin advance-tag-my-calendar d-block"
              href={"/"}
            >
              {t("bookingConfirm.continue")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
